import Form from 'react-bootstrap/Form'
import {useState,useEffect} from 'react'

import css from './FoodPortionSelect.module.css'

export default function FoodPortionSelect({initialPortionId,onChange,portions,qty=1,enableRootClose=true}){
	const [showPortions,setShowPortions] = useState(false)
	const [portionId,setPortionId] = useState(initialPortionId)
	useEffect(()=>{
		if (!enableRootClose) return 
		function closePortionSelect(){
			setShowPortions(false)
		}
		document.body.addEventListener('click',closePortionSelect)
		return ()=>{
			document.body.removeEventListener('click',closePortionSelect)
		}
	},[])
	useEffect(()=>{
		setPortionId(initialPortionId)
	},[initialPortionId])
	
	const portion = portions.find(
		p => parseInt(p.id) === parseInt(portionId)
	) || portions[0]

	if (!portions.length) return null
	return (
		<small onClick={e=>{e.stopPropagation()}} className="text-muted d-flex align-items-center flex-wrap">
			<span className={[
				css.FoodPortionSelect,
				"text-primary mr-1"
			].join(' ')}>
				<div 
					onClick={(e)=>{
						setShowPortions(p=>!p)
					}}
					className={css.FoodPortion}
					tabindex="0"
				>
					<i className="fas fa-caret-down mr-1"/>
					{Boolean(portion.description)&&
						<span className="ml-1">
							{portion.description}
						</span>
					}
					{(portion.unit!=='g'&&portion.unit!=='not specified')&&
						<span className="ml-1">
							({portion.gram_weight}g)
						</span>
					}
				</div>
				{showPortions&&
					<div className={css.FoodPortions}>
						{portions.map(portion=>(
							<div onClick={()=>{
								setPortionId(portion.id)
								if (typeof onChange === 'function') onChange(portion)
								setShowPortions(false)
							}} className={css.FoodPortion}>
								{Boolean(portion.description)&&
									<span className="ml-1">
										{portion.description}
									</span>
								}
								{(portion.unit!=='g'&&portion.unit!=='not specified')&&
									<span className="ml-auto">
										({portion.gram_weight}g)
									</span>
								}
							</div>
						))}
					</div>
				}
			</span>
			cal: {(qty*portion.calories).toFixed(0)} pro: {(qty*portion.protein).toFixed(0)} carbs: {(qty*portion.carbs).toFixed(0)} fat: {(qty*portion.fat).toFixed(0)} sod: {(qty*portion.sodium).toFixed(0)} fib: {(qty*portion.fiber).toFixed(0)}
		</small>
	)
}